import React, { useState } from 'react';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { DashboardSidebar } from '../components/dashboard/DashboardSidebar';
import { SearchFilters } from '../components/search/SearchFilters';
import { SearchResults } from '../components/search/SearchResults';
import { AdvancedSearch } from '../components/search/AdvancedSearch';
import { SaveSearchModal } from '../components/search/SaveSearchModal';
import { SearchIcon, SlidersIcon, BookmarkIcon } from 'lucide-react';
export function SearchDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [showSaveSearchModal, setShowSaveSearchModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilters, setSelectedFilters] = useState({
    countries: [],
    sectors: [],
    budgetMin: '',
    budgetMax: '',
    dateRange: null
  });
  // Mock user data (same as in Dashboard.tsx)
  const user = {
    name: 'FATHALLAH Mehdi',
    company: 'Tunipages',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    email: 'mehdi.fathallah@tunipages.com',
    phone: '+216 71 234 567'
  };
  const handleSearch = () => {
    // In a real application, this would trigger an API call with the search parameters
    console.log('Searching for:', searchQuery);
    console.log('With filters:', selectedFilters);
  };
  const handleFilterChange = newFilters => {
    setSelectedFilters({
      ...selectedFilters,
      ...newFilters
    });
  };
  const handleSaveSearch = searchName => {
    // In a real application, this would save the search to the user's account
    console.log('Saving search:', searchName);
    console.log('Query:', searchQuery);
    console.log('Filters:', selectedFilters);
    setShowSaveSearchModal(false);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-3505">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarOpen(false)} data-id="element-3506" />}
      {/* Sidebar */}
      <DashboardSidebar open={sidebarOpen} setOpen={setSidebarOpen} data-id="element-3507" />
      {/* Main content */}
      <div className="md:pl-64" data-id="element-3508">
        {/* Header */}
        <DashboardHeader user={user} onMenuClick={() => setSidebarOpen(true)} data-id="element-3509" />
        {/* Main dashboard content */}
        <main className="py-6 px-4 sm:px-6 lg:px-8" data-id="element-3510">
          {/* Search header */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden mb-6" data-id="element-3511">
            <div className="p-6" data-id="element-3512">
              <h1 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-3513">
                Recherche d'appels d'offres
              </h1>
              <div className="relative" data-id="element-3514">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3515">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-3516" />
                </div>
                <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Rechercher par mot-clé, référence, pays..." className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3517" />
              </div>
              <div className="mt-4 flex flex-wrap items-center justify-between gap-3" data-id="element-3518">
                <div className="flex flex-wrap items-center gap-2" data-id="element-3519">
                  <button onClick={() => setShowAdvancedSearch(!showAdvancedSearch)} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-3520">
                    <SlidersIcon size={16} className="mr-2" data-id="element-3521" />
                    {showAdvancedSearch ? 'Masquer les filtres avancés' : 'Filtres avancés'}
                  </button>
                  <button onClick={() => setShowSaveSearchModal(true)} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-3522">
                    <BookmarkIcon size={16} className="mr-2" data-id="element-3523" />
                    Enregistrer la recherche
                  </button>
                </div>
                <button onClick={handleSearch} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-3524">
                  <SearchIcon size={16} className="mr-2" data-id="element-3525" />
                  Rechercher
                </button>
              </div>
            </div>
            {/* Advanced search filters */}
            {showAdvancedSearch && <AdvancedSearch filters={selectedFilters} onFilterChange={handleFilterChange} data-id="element-3526" />}
          </div>
          {/* Applied filters */}
          <SearchFilters filters={selectedFilters} onFilterChange={handleFilterChange} data-id="element-3527" />
          {/* Search results */}
          <div className="mt-6" data-id="element-3528">
            <SearchResults query={searchQuery} filters={selectedFilters} data-id="element-3529" />
          </div>
        </main>
      </div>
      {/* Save search modal */}
      {showSaveSearchModal && <SaveSearchModal onSave={handleSaveSearch} onClose={() => setShowSaveSearchModal(false)} data-id="element-3530" />}
    </div>;
}